import {
  API,
  BlockAPI,
  BlockTool,
  BlockToolConstructorOptions,
} from "@editorjs/editorjs";
import Ui from "./ui";
import { AccordianConfig, AccordianData } from "./types";
import { MenuConfig } from "@editorjs/editorjs/types/tools";

type AccordianToolConstructorOptions = BlockToolConstructorOptions<
  AccordianData,
  AccordianConfig
>;

export class AccordianTool implements BlockTool {
  private api: API;

  private block: BlockAPI;

  private config: AccordianConfig;

  private ui: Ui;

  private _data: AccordianData;

  static get toolbox() {
    return {
      title: "Accordion",
      icon: Ui.toolBoxIcon,
    };
  }

  constructor({
    data,
    config,
    api,
    readOnly,
    block,
  }: AccordianToolConstructorOptions) {
    this._data =
      Object.keys(data).length === 0
        ? {
            title: "Accordion Title",
            showTitle: true,
            themeKey: config?.themeKey || "variant1",
            contentData: [
              {
                id: crypto.randomUUID(),
                title: "",
                contentBlocks: [{ type: "text", value: "" }],
              },
            ],
          }
        : data;
    this.config = config ?? {
      uploadService: async () => {
        alert("Upload service not defined");
        return { url: "" };
      },
    };
    this.api = api;
    this.block = block;
    this.ui = new Ui({ data: this._data, api, config: this.config, readOnly });
    this.ui.tune({ showTitle: this._data.showTitle });
  }

  public render(): HTMLElement {
    return this.ui.render();
  }

  public renderSettings(): HTMLElement | MenuConfig {
    return this.ui.renderSettings(this._data);
  }

  private set data(data: any) {
    this._data = data;
  }

  private get data(): any {
    return this._data;
  }

  public save() {
    this.data = this.ui.getUiData;
    return {
      ...this.data,
      themeKey: this.config?.themeKey || this.data.themeKey,
    };
  }

  static get enableLineBreaks() {
    return true;
  }

  static get contentless() {
    return false;
  }

  static get isReadOnlySupported() {
    return true;
  }

  public static get pasteConfig() {
    return {
      tags: ["DIV"],
    };
  }
}
